<template>
    <div>
        <div class="layout">
            <ProductListView @current-change="handleCurrentChange" ref="ProductListView"></ProductListView>
        </div>
        <div class="layout">
            <!-- 扩展标签 -->
            <el-tabs v-if="productId" v-model="tabActive">
                <el-tab-pane label="课程详情" name="CourseListView">
                    <CourseListView :productId="productId" ref="CourseListView"></CourseListView>
                </el-tab-pane>
                <el-tab-pane label="视频信息" name="VideoListView">
                    <VideoListView :productId="productId" ref="VideoListView"></VideoListView>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import ProductListView from "@/views/Back/Product/ProductListView.vue"
import CourseListView from "@/views/Back/Course/CourseListView.vue"
import VideoListView from "@/views/Back/Video/VideoListView.vue"

export default {
    components: {
        ProductListView,
        VideoListView,
        CourseListView
    },
    data: function () {
        return {
            tabActive: "CourseListView",
            productId: ""
        }
    },
    methods: {
        handleCurrentChange: function(val) {
            console.log(val)
            this.productId = val;
            this.$forceUpdate();
        },
    }
}
</script>
<style scoped lang="less">
    @import "@/assets/style/list-style.less";
    @import "@/assets/style/upload-style.less";
</style>